import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetUserOtherSubjectsAction, userAction} from '../action';

const tableId = 'userOtherSubjectRolesProfile';

function* execute({payload: {request: tableDataRequest}}: GetUserOtherSubjectsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.findLoggedInUserOtherSubjectRoles,
        successAction: userAction.getOtherSubjectsSuccess,
        tableId,
    }));
}

export function* getUserOtherSubjectsSaga(): SagaIterator {
    yield takeLatestF('user/GET_USER_OTHER_SUBJECTS', execute);
}
